import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";
import { getCurrentUser, resetCurrentUser } from "./currentUserService";
import { getDocument } from "api/index";

//-------------------------------------------
//           API Functions
//-------------------------------------------

const USER_BASE = "/Users";

const getUsersAPI = () => API.get(`${USER_BASE}`);
const addNewUserAPI = (data) =>
  API.post(`${USER_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
const updateUserAPI = (id, data) =>
  API.patch(`${USER_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
const getUserByIdAPI = (id) => API.get(`${USER_BASE}/${id}`);

//-------------------------------------------
//             User Service
//-------------------------------------------

const baseService = createApplicationService({
  name: "users",
  apiFetchFn: getUsersAPI,
  apiAddFn: addNewUserAPI,
  apiUpdateFn: updateUserAPI,
});

const usersReducer = baseService.reducer;
const getUsers = baseService.getData;
const addUser = baseService.addData;
//const updateUser = baseService.updateData;
const useUsers = baseService.useData;

const updateUser = async (id, data) => {
  const result = await baseService.updateData(id, data);
  if (result.success) {
    const currentUser = await getCurrentUser();
    if (currentUser.userID === id) {
      resetCurrentUser();
    }
  }
  return result;
};

const getActiveFeeEarner = async () => {
  const allUsers = await getUsers();
  return allUsers?.filter((item) => item.active && item.isFeeEarner) || [];
};

const getUserInfo = async (id) => {
  if (!id) return null;
  const allUsers = await getUsers();
  return allUsers?.find((user) => user.userID === id) || null;
};

const getUserById = async (id) => {
  if (!id) return null;
  try {
    const response = await getUserByIdAPI(id);
    const userData = response.data?.data;
    
    if (!userData) return null;
    
    // If user has a profile photo, fetch it and add to the user object
    if (userData.userImageDocumentId) {
      try {
        const photoResponse = await getDocument(userData.userImageDocumentId);
        userData.imageInfo = photoResponse.data.data;
      } catch (error) {
        console.warn("Failed to fetch user profile photo:", error);
        // Continue without photo if fetch fails
      }
    }
    
    return userData;
  } catch (error) {
    console.error("Error fetching user by ID:", error);
    return null;
  }
};

const getUserSearch = async (searchVal) => {
  const users = await getUsers();
  if (!searchVal || searchVal.trim() === "") {
    return users;
  }
  const searchTerm = searchVal.toLowerCase().trim();
  const searchedUsers = await users.filter(
    (user) =>
      user.displayname.toLowerCase().startsWith(searchTerm) ||
      user.emailAddress.toLowerCase().includes(searchTerm)
  );

  return searchedUsers;
};

const useActiveFeeEarner = () => {
  const { data, loading } = useUsers();
  const filteredData =
    data?.filter((item) => item.active && item.isFeeEarner) || [];
  return { data: filteredData, loading };
};

export {
  usersReducer,
  getUsers,
  addUser,
  updateUser,
  useUsers,
  getActiveFeeEarner,
  getUserSearch,
  getUserInfo,
  getUserById,
  useActiveFeeEarner,
};
